module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-6.0b806c22.png";